module.exports = "/packs/media/images/house-88750dcd9b3029fb379360b3c7d20825.jpg";